module.exports = __webpack_public_path__ + "static/16-c7228d9eb2f40de312930c72e4de2583.png";